/**
 * Age verification page:
 * private Cloudflare Worker/R2 upload → Shopify contact email with opaque reference.
 * iPhone HEIC/HEIF photos are converted to JPEG in the browser before upload.
 */
(function () {
  var HEIC2ANY_SRC = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
  var heic2anyLoader = null;

  function $(id) {
    return document.getElementById(id);
  }

  function prefillOrderFromQuery() {
    var params = new URLSearchParams(window.location.search);
    var order = params.get('order') || params.get('order_number') || params.get('orderNumber');
    if (!order) return;
    var el = $('bp-age-order-number');
    if (el && !el.value) el.value = decodeURIComponent(String(order).replace(/^#/, ''));
  }

  function buildContactBody(orderNum, orderName, email, reference) {
    return [
      'AGE VERIFICATION ID UPLOAD',
      '---',
      'Order number: ' + orderNum,
      'Name on order: ' + orderName,
      'Customer email: ' + email,
      'Private upload reference: ' + reference,
      '---',
      'Open the private Cloudflare staff portal to view the ID.',
      'Customer confirmed: name on ID matches name on order.',
      'Submitted from: ' + window.location.href
    ].join('\n');
  }

  function isHeicLike(file) {
    if (!file) return false;
    var type = String(file.type || '').toLowerCase();
    var name = String(file.name || '').toLowerCase();
    return (
      type === 'image/heic' ||
      type === 'image/heif' ||
      type === 'image/heic-sequence' ||
      type === 'image/heif-sequence' ||
      name.endsWith('.heic') ||
      name.endsWith('.heif')
    );
  }

  function loadHeic2Any() {
    if (window.heic2any) return Promise.resolve(window.heic2any);
    if (heic2anyLoader) return heic2anyLoader;
    heic2anyLoader = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-bp-heic2any]');
      if (existing) {
        existing.addEventListener('load', function () {
          if (window.heic2any) resolve(window.heic2any);
          else reject(new Error('HEIC converter failed to load'));
        });
        existing.addEventListener('error', function () {
          reject(new Error('HEIC converter failed to load'));
        });
        return;
      }
      var script = document.createElement('script');
      script.src = HEIC2ANY_SRC;
      script.async = true;
      script.setAttribute('data-bp-heic2any', '1');
      script.onload = function () {
        if (window.heic2any) resolve(window.heic2any);
        else reject(new Error('HEIC converter failed to load'));
      };
      script.onerror = function () {
        reject(new Error('HEIC converter failed to load'));
      };
      document.head.appendChild(script);
    });
    return heic2anyLoader;
  }

  function jpegNameFrom(file) {
    var base = String(file && file.name ? file.name : 'id-photo')
      .replace(/\.(heic|heif)$/i, '')
      .replace(/[^\w.\-]+/g, '_')
      .slice(0, 120);
    if (!base) base = 'id-photo';
    return base + '.jpg';
  }

  function ensureUploadableImage(file) {
    if (!isHeicLike(file)) return Promise.resolve(file);

    return loadHeic2Any()
      .then(function (heic2any) {
        return heic2any({
          blob: file,
          toType: 'image/jpeg',
          quality: 0.92
        });
      })
      .then(function (result) {
        var blob = Array.isArray(result) ? result[0] : result;
        if (!blob) throw new Error('Could not convert iPhone photo');
        return new File([blob], jpegNameFrom(file), { type: 'image/jpeg' });
      })
      .catch(function () {
        // Fall through: worker also accepts HEIC if browser conversion fails.
        return file;
      });
  }

  function uploadIdFile(uploadUrl, file, orderNum, orderName, email) {
    var fd = new FormData();
    fd.append('file', file);
    fd.append('order', orderNum);
    fd.append('name', orderName);
    fd.append('email', email);

    return fetch(uploadUrl, {
      method: 'POST',
      body: fd,
      mode: 'cors'
    }).then(function (res) {
      return res.json().catch(function () {
        return {};
      }).then(function (payload) {
        if (!res.ok) throw new Error(payload.error || 'Upload failed');
        return payload;
      });
    }).then(function (payload) {
      if (!payload.reference) throw new Error('Upload reference missing');
      return payload.reference;
    });
  }

  function submitContactForm(form, body, customerName) {
    $('bp-age-contact-body').value = body;
    $('bp-age-contact-name-hidden').value = customerName || 'Age verification upload';

    function doNativeSubmit() {
      // Shopify replaces form.submit with a wrapper that fetches the hCaptcha
      // token and then calls the real submit. That wrapper does not re-fire
      // this listener. The prototype submit skips the token.
      if (typeof form.submit === 'function' && form.submit !== HTMLFormElement.prototype.submit) {
        form.submit();
        return;
      }
      HTMLFormElement.prototype.submit.call(form);
    }

    // Shopify spam protection: programmatic submit must go through captcha.protect
    // or the store returns "Missing CAPTCHA token".
    if (
      window.Shopify &&
      window.Shopify.captcha &&
      typeof window.Shopify.captcha.protect === 'function'
    ) {
      window.Shopify.captcha.protect(form, doNativeSubmit);
      return;
    }

    doNativeSubmit();
  }

  function init() {
    var form = $('bp-age-verification-form');
    if (!form) return;

    prefillOrderFromQuery();

    var sectionEl = $('age-verification-upload');
    var submitLabel =
      (sectionEl && sectionEl.getAttribute('data-submit-label')) || 'Submit ID for verification';
    var uploadUrl = sectionEl && sectionEl.getAttribute('data-upload-url');

    // Capture phase, and stop the event, so Shopify's contact-form captcha
    // cannot native-submit this form before the private upload finishes.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var errEl = $('bp-age-form-error');
      if (errEl) {
        errEl.hidden = true;
        errEl.textContent = '';
      }

      var orderNum = ($('bp-age-order-number').value || '').trim();
      var orderName = ($('bp-age-order-name').value || '').trim();
      var email = ($('bp-age-customer-email').value || '').trim();
      var confirm = $('bp-age-name-confirm');
      var fileInput = $('bp-age-id-file');
      var file = fileInput && fileInput.files && fileInput.files[0];

      if (!orderNum || !orderName || !email) {
        if (errEl) {
          errEl.textContent = 'Please fill in all required fields.';
          errEl.hidden = false;
        }
        return;
      }
      if (!confirm || !confirm.checked) {
        if (errEl) {
          errEl.textContent = 'Please confirm that the name on your ID matches your order.';
          errEl.hidden = false;
        }
        return;
      }
      if (!file) {
        if (errEl) {
          errEl.textContent = 'Please upload a photo of your ID before submitting.';
          errEl.hidden = false;
        }
        return;
      }
      if (!uploadUrl) {
        if (errEl) {
          errEl.textContent = 'Private upload service is not configured. Please contact us.';
          errEl.hidden = false;
        }
        return;
      }

      var btn = $('bp-age-submit-btn');
      if (btn) {
        btn.disabled = true;
        btn.textContent = isHeicLike(file) ? 'Converting photo…' : 'Sending…';
      }

      ensureUploadableImage(file)
        .then(function (uploadFile) {
          if (btn) btn.textContent = 'Sending…';
          return uploadIdFile(uploadUrl, uploadFile, orderNum, orderName, email);
        })
        .then(function (reference) {
          submitContactForm(
            form,
            buildContactBody(orderNum, orderName, email, reference),
            orderName
          );
        })
        .catch(function (error) {
          if (errEl) {
            errEl.textContent = error && error.message
              ? error.message
              : 'We could not securely send your ID. Please try again.';
            errEl.hidden = false;
          }
          if (btn) {
            btn.disabled = false;
            btn.textContent = submitLabel;
          }
        });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
